import {Record} from 'immutable';

const InquiryAction = Record({
    inquiryActionId: '',
    inquiryId: '',
    createdBy: '',
    createdAt: '',
    due: '',
    lastUpdatedAt: '',
    lastUpdatedBy: '',
    note: '',
    subject: '',
    type: '',
    edit: false,
    updating: false,
    deleting: false,
});

function fromAPI(data) {
    return new InquiryAction({
        ...data,
    });
}

const toAPI = inquiry => inquiry.toJS();

export default {
    record: InquiryAction,
    default: new InquiryAction(),
    fromAPI,
    toAPI,
};
